import React, { useState } from "react";

import ThumbUp from "./ThumbUp";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  button: {
    cursor: "pointer",
    border: "0 none transparent !important",
    backgroundColor: "transparent !important",
    marginRight: "10px",
    width: "27px",
    height: "27px !important",
  },
  flipHorizontal: {
    WebkitTransform: "scale(-1, -1)",
    transform: "scale(-1, -1)",
  },
});

const THUMB_UP = "THUMB_UP";
const THUMB_DOWN = "THUMB_DOWN";

export default ({ handleFeedback }) => {
  const styles = useStyles();
  const [feedback, setFeedback] = useState();

  const onFeedback = (val) => {
    setFeedback(val);
    handleFeedback(val);
  };

  const isEnabled = () => feedback === undefined;

  return (
    <div>
      <button
        className={styles.button}
        disabled={!isEnabled()}
        onClick={() => {
          onFeedback(THUMB_UP);
        }}
      >
        <ThumbUp isSelected={feedback === THUMB_UP} isEnabled={isEnabled()} />
      </button>
      <button
        className={[styles.button, styles.flipHorizontal].join(" ")}
        disabled={!isEnabled()}
        onClick={() => {
          onFeedback(THUMB_DOWN);
        }}
      >
        <ThumbUp isSelected={feedback === THUMB_DOWN} isEnabled={isEnabled()} />
      </button>
    </div>
  );
};
